var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.ShowButtons)?_c('span',{staticClass:"dropdown"},[_c('a',{staticClass:"btn btn-primary-t dropdown-toggle dropdown-toggle-ll",attrs:{"href":"#","role":"button","data-bs-toggle":"dropdown","aria-expanded":"false"}}),_c('ul',{staticClass:"dropdown-menu dropdown-menu-end"},[_vm._t("bodyBtnsL")],2)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }